import { FormControlLabel, FormHelperText, Switch } from '@mui/material'
import { ChangeEvent } from 'react'
import { useFormikContext } from 'formik'
import { useIntegrationsAccess } from '../store/integrations-access'

export function IntegrationsEnabledSwitch() {
  const formik = useFormikContext<{ enabled: boolean }>()
  const { canEdit, canDelete } = useIntegrationsAccess()
  const turningOff = formik.values.enabled
  const switchDisabled = turningOff ? !canDelete : !canEdit

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked && !canEdit) return
    if (!event.target.checked && !canDelete) return
    formik.handleChange(event)
  }

  return (
    <>
      <FormControlLabel
        sx={{ alignSelf: 'flex-end' }}
        labelPlacement="start"
        control={
          <Switch
            color="primary"
            checked={formik.values.enabled}
            onChange={handleChange}
            id="enabled"
            name="enabled"
            disabled={switchDisabled}
          />
        }
        label="Enabled"
      />
      <FormHelperText error>
        {formik.touched.enabled && Boolean(formik.errors.enabled) ? formik.errors.enabled : null}
      </FormHelperText>
    </>
  )
}
